const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';
const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-grid-item',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
  updateWishlistCount();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    // console.log("button from setupButtons",button)
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)){
      button.classList.add(BUTTON_ACTIVE_CLASS);
      // to display add wishlist / remove wishlist
      try{
        let button_text = button.querySelector('.btn__inner').querySelector('.btn__text')
        button_text.innerText = "Remove Wishlist"
      }
      catch(err) {
      }

    } 
    button.addEventListener('click', () => {
      // to display add wishlist / remove wishlist
      updateWishlist(productHandle, button);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      updateWishlistCount();
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  // console.log("buttons",buttons)
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const updateWishlistCount= () => {
  
  wishlist_count = getWishlist().length
  // console.log("getWishlist()",getWishlist().length)
  $('.wishlist-count-bubble span').text(wishlist_count)

  if (wishlist_count > 0){
    // $('.menu.icon-heart').addClass('active')
    $('.wishlist-count-bubble').removeClass('hidden')
    
  }
  else{
    // $('.menu.icon-heart').removeClass('active')
    $('.wishlist-count-bubble').addClass('hidden')
  }
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle, button) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) {
    wishlist.push(handle)
    // to display add wishlist / remove wishlist
    try{
      let button_text = button.querySelector('.btn__inner').querySelector('.btn__text')
      button_text.innerText = "Remove Wishlist"
    }
    catch(err) {
    }
  }
  else {
    wishlist.splice(indexInWishlist, 1)
    try{
      let button_text = button.querySelector('.btn__inner').querySelector('.btn__text')
      button_text.innerText = "Add Wishlist"
    }
    catch(err) {
    }

  }
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};